import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";

export const Services = () => (
  <section id="services" className="scroll-mt-24 bg-background py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Reveal>
            <Overline>What We Offer</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight text-white md:text-5xl">
              A wide range of chauffeured services
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-sm font-light leading-relaxed text-zinc-400">
            Effortless booking, available 24/7. Rely on us for last-minute travel and the moments that matter most.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`service-${s.id}`}
            className={`group relative flex min-h-[340px] flex-col justify-end overflow-hidden border border-white/5 ${s.span}`}
          >
            <img
              src={s.image}
              alt={s.title}
              className="absolute inset-0 h-full w-full object-cover opacity-50 grayscale transition-all duration-700 group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
            <div className="relative z-10 p-8">
              <s.icon className="mb-5 h-7 w-7 text-primary" />
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-serif text-2xl font-normal text-white md:text-3xl">{s.title}</h3>
                <ArrowUpRight className="h-6 w-6 shrink-0 text-primary transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-zinc-300">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
